module.exports = __webpack_public_path__ + "components/flag/static/square/mk-e99fcd351d13d7f60adb35a091083415.svg";